export default __webpack_public_path__ + "static/media/handshake-businessmen.58bcb480.jpg";